// extracted by mini-css-extract-plugin
module.exports = {"container":"fk","image":"fl","title":"fm","desc":"fn"};